<template>
    <div>
        <b-card no-body v-show="mostrarMensagens">
            <b-card-header>
                <h5>
                    MENSAGENS
                    <b-button variant="primary" class="float-right" @click.stop="novaMensagem()">
                        <i class="fa fa-plus mr-2"></i>Nova Mensagem
                    </b-button>
                </h5>
            </b-card-header>
            <b-card-body>
                <b-tabs card>
                    <b-tab active class="pb-0">
                        <template v-slot:title>
                            <h5>
                                Recebidas
                                <b-badge variant="primary">{{ mensagens.qtdMensagensNaoLidas }}</b-badge>
                            </h5>
                        </template>
                        <recebidas :mensagens="mensagens.recebidas"></recebidas>
                    </b-tab>
                    <b-tab>
                        <template v-slot:title>
                            <h5>Enviadas</h5>
                        </template>
                        <enviadas :mensagens="mensagens.enviadas"></enviadas>
                    </b-tab>
                    <b-tab>
                        <template v-slot:title>
                            <h5>Rascunhos</h5>
                        </template>
                        <rascunhos
                            :mensagens="mensagens.rascunhos"
                            @obterMensagensAtualizadas="obterMensagens()"
                        ></rascunhos>
                    </b-tab>
                </b-tabs>
            </b-card-body>
        </b-card>
        <router-view @obterMensagensAtualizadas="obterMensagens()"></router-view>
    </div>
</template>

<script>
import MensagensServicos from './MensagensServicos'
import Recebidas from './Recebidas'
import Enviadas from './Enviadas'
import Rascunhos from './Rascunhos'

export default {
	//   props: {
	//     expressoPlanilhas: {
	//       type: Array,
	//       default: () => ([])
	//     }
	//   },
	components: {
		Recebidas,
		Enviadas,
		Rascunhos
	},

	data() {
		return {
			mensagens: {}
			// 	fornecedores: [],
			// 	fornecedor: {},
			// 	campos: [
			// 		{
			// 			key: 'cpfCnpj',
			// 			label: 'CNPJ',
			// 			sortable: true,
			// 			filterable: true
			// 		},
			// 		{
			// 			key: 'razaoSocial',
			// 			label: 'Fornecedor',
			// 			sortable: true,
			// 			filterable: true
			// 		},
			// 		{
			// 			key: 'acoes',
			// 			label: 'Ações'
			// 		}
			// 	],
			// 	itensPorPagina: 10
		}
	},

	methods: {
		obterMensagens() {
			this.$store.dispatch('addRequest')
			MensagensServicos.obterTodas().then(response => {
				if (response) {
					if (response.success) {
						this.mensagens = response.data
					} else {
						this.$toast.error(
							'Erro ao obter as Mensagens',
							'ERROR',
							this.$toastConfig.error
						)
					}
				}
				this.$store.dispatch('removeRequest')
			})
		},

		// detalharFornecedor(fornecedorId) {
		// 	this.fornecedor = this.fornecedores.filter(p => {
		// 		return p.fornecedorId == fornecedorId
		// 	})[0]
		// 	this.$router.push({
		// 		name: 'Fornecedores_Detalhar',
		// 		params: {
		// 			fornecedorId
		// 		}
		// 	})
		// }

		novaMensagem() {
			this.$router.push({
				name: 'Mensagens_Inserir'
			})
		}
	},

	created() {
		this.obterMensagens()
	},

	computed: {
		mostrarMensagens() {
			return this.$route.name == 'Mensagens'
		}
	},

	watch: {}
}
</script>
